export default "__VITE_ASSET__Dyame5BM__"